
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people/board/[slug]",
      function () {
        return require("private-next-pages/people/board/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/people/board/[slug]"])
      });
    }
  